import AccountActivities from "./AccountActivities"

export default AccountActivities
